import { usePermission } from '@backstage/plugin-permission-react';
import { runMaintenanceTaskPermissions } from "@internal/backstage-plugin-supply-features-common";
import { Box, Button, Card, CardContent, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import React, { useState } from 'react';
import { MaintenanceTask } from "./MaintenanceTask";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
      card: {
        width: '100%',
        minHeight: 200,
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
      },
      actionButtons: {
        marginTop: theme.spacing(3),
        '& > *': {
          marginRight: theme.spacing(2),
          minWidth: 175,
          minHeight: 40
        }
      },
      
  })
);

export const ScheduleConfiguration = () => {

  const classes = useStyles();

  const [maintenaceTaskDialogOpen, setMaintenaceTaskDialogOpen] = useState(false);

  // Permissions
  const allowedRunMaintenancePermission = usePermission({ permission: runMaintenanceTaskPermissions }).allowed;

  return (
    <>
      <Box display="flex" gridColumnGap={16}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6">Actions</Typography>
              <Typography variant="subtitle1">Manage and execute scheduler-related actions</Typography>
            <Box display="flex" className={classes.actionButtons}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setMaintenaceTaskDialogOpen(true)}
                disabled={!allowedRunMaintenancePermission}
              >
                Run maintenance tasks
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>

      { maintenaceTaskDialogOpen &&
        <MaintenanceTask
          open={maintenaceTaskDialogOpen}
          handleClose={() => setMaintenaceTaskDialogOpen(false)}
        />}
    </>
  );
};
